(function () {
    var msDateRE = /^\/Date\((\d+)\)\/$/;
    if ('angular' in window) {
        angular.element(document).ready(function () {
            var modules = [];
            if ('st' in window && st.modules) {
                modules = st.modules;
            }
            
            angular.module('st', [])
                .filter('format', function () {
                    return function (formatStr, items) {
                        if (!items || !items.length) {
                            return formatStr;
                        }
                        return items.reduce(function (formatted, item, i) {
                            return formatted.replace(new RegExp('\\{' + i + '\\}'), item);
                        }, formatStr);
                    };
                })
                .filter('msDate', ['$filter', function ($filter) {
                    return function (input, format, timezone) {
                        var ms;
                        if (input && (ms = input.match(msDateRE))) {
                            return $filter('date')(ms[1], format, timezone);
                        }
                        return $filter('date')(input, format, timezone);
                    };
                }])
                .config(['$locationProvider', function ($locationProvider) {
                    $locationProvider.html5Mode({
                        enabled: true,
                        requireBase: false,
                        rewriteLinks: false
                    });
                }])
                .config(['$httpProvider', function($httpProvider) {
                    //get
                    if (!$httpProvider.defaults.headers.get) {
                        $httpProvider.defaults.headers.get = {};    
                    }
                    $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                    $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
                    //post
                    if (!$httpProvider.defaults.headers.post) {
                        $httpProvider.defaults.headers.post = {};    
                    }    
                    $httpProvider.defaults.headers.post['Cache-Control'] = 'no-cache';
                    $httpProvider.defaults.headers.post['Pragma'] = 'no-cache';
                }]);

            // add any custom modules used in this project in the array below
            //angular.bootstrap(document.body, modules);
        });
    }
})();